import { DataType } from '@inpart-io/padme-iap';

import { ICONS_NAME } from './ui/icons.constants';

export const attachmentIcons = [
    'fas fa-file-alt',
    'fas fa-file-contract',
    'fas fa-file-spreadsheet',
    'fas fa-file-chart-pie',
    'fas fa-file-pdf',
    'fas fa-image'
];

export const SUPPORT_FOLDER: string[] = [DataType.AgreementDetail, DataType.Lead, DataType.PrivateCompany];

export const SUPPORTED_FILES = '.xls, .xlsx, .eml, .msg, .ppt, .pptx, .doc, .docx, .pdf, .jpg, .jpeg, .png';

export const ICON_TYPE: Record<string, string> = {
    jpg: ICONS_NAME.FILE_ICON_IMG,
    jpeg: ICONS_NAME.FILE_ICON_IMG,
    png: ICONS_NAME.FILE_ICON_IMG,
    xls: ICONS_NAME.FILE_ICON_EXCEL,
    xlsx: ICONS_NAME.FILE_ICON_EXCEL,
    ppt: ICONS_NAME.FILE_ICON_POWERPOINT,
    pptx: ICONS_NAME.FILE_ICON_POWERPOINT,
    odp: ICONS_NAME.FILE_ICON_POWERPOINT,
    doc: ICONS_NAME.FILE_ICON_WORD,
    docx: ICONS_NAME.FILE_ICON_WORD,
    pdf: ICONS_NAME.FILE_ICON_PDF
};

export const VALID_FILE_NAME = /^.{1,255}\.(xls|XLS|xlsx|XLSX|eml|EML|msg|MSG|ppt|PPT|pptx|PPTX|doc|DOC|docx|DOCX|pdf|PDF|jpg|JPG|jpeg|JPEG|png|PNG)$/;

export const MAX_FILE_SIZE = 104857600;
export const MIN_FILE_SIZE = 1000;

export const MAX_FILE_SIZE_STRING = '100';
export const MIN_FILE_SIZE_STRING = '1';

export const MAX_FILES = 20;
